import cn from 'clsx'

import React from 'react'
type Props = {
  actions?: React.ReactNode
  appearance?: 'circle' | 'square'
  info?: React.ReactNode
  visible?: boolean
}

const Overlay = ({
  actions,
  appearance = 'square',
  info,
  visible,
}: Props): React.ReactElement<'div'> => {
  return (
    <div
      className={cn('GridItem-overlay', {
        'GridItem-overlay--circle': appearance === 'circle',
        'GridItem-overlay--square': appearance === 'square',
        'GridItem-overlay--visible': visible,
      })}
    >
      {actions && <div className="GridItem-overlay-actions">{actions}</div>}
      {info && <div className="GridItem-overlay-info">{info}</div>}
    </div>
  )
}

export default Overlay
